import { SessionDto } from "@se/platform";
import { Observable } from "rxjs";

const ISessionServiceId = Symbol("ISessionServiceId");

interface ISessionService {

    StartSession();
    EndSession();

    OnSessionStarted$(): Observable<SessionDto>;
    OnSessionEnded$(): Observable<SessionDto>;

};

export { ISessionServiceId, ISessionService }